<section class="mu-home" *ngIf="!showImport">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 text-end">
              <a
                ><button type="button" class="btn-actvtytp" (click)="showImport = !showImport">BULK IMPORT</button></a
              >
            </div>
            <div class="col-md-12 mb-2 empl-tptxt">
              <h3>{{ calendarId ? 'View' : 'New' }} Calendar Activity</h3>
            </div>
            <div class="col-12 col-md-6">
              <form [formGroup]="calendarEventForm">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Task Due Date <sup>*</sup></label>
                      <input
                        type="date"
                        class="form-control"
                        id="exampleFormControlInput1"
                        formControlName="dueDatetime"
                        [ngClass]="{ 'is-invalid': f['dueDatetime'].errors && f['dueDatetime'].touched }" />
                      <app-validation
                        field="dueDatetime"
                        [form]="calendarEventForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly select Task Due Date',
                          invalid: 'Task Due Date must be today or in the future'
                        }"></app-validation>
                    </div>
                  </div>

                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <app-company-selector
                        [companyId]="calendarDetail?.companyEntityId"
                        (selectedValueChange)="handleCompanySelectedValue($event)"></app-company-selector>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="mb-3">
                      <label for="exampleFormControlTextarea1" class="form-label"> Task Description <sup>*</sup></label>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="4"
                        formControlName="displayDescription"
                        [ngClass]="{
                          'is-invalid': f['displayDescription'].errors && f['displayDescription'].touched
                        }"></textarea>
                      <app-validation
                        field="dueDatetime"
                        [form]="calendarEventForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly enter Task Description',
                          minLength: 'Task Description should have minimum length of 5',
                          maxLength: 'Task Description length cannot exceed 150 characters'
                        }"></app-validation>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="col-12 mb-2">
                      <label for="exampleFormControlInput1" class="form-label">Display Task for</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="Employee"
                        [checked]="displayForEmployee"
                        (change)="displaySelectEmployee($event)" />
                      <label class="form-check-label" for="pfRadio">Employee</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="Employer"
                        [checked]="displayForEmployer"
                        (change)="displaySelectEmployer($event)" />
                      <label class="form-check-label" for="pfRadio">Employer</label>
                    </div>
                  </div>
                  <div class="col-12 mb-2"></div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Display Task From <sup>*</sup></label>
                      <input
                        type="date"
                        class="form-control"
                        formControlName="displayFromDatetime"
                        id="exampleFormControlInput1"
                        [ngClass]="{
                          'is-invalid': f['displayFromDatetime'].errors && f['displayFromDatetime'].touched
                        }" />
                      <app-validation
                        field="displayFromDatetime"
                        [form]="calendarEventForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly select Display Task From Date',
                          invalid: 'Valid From date must be today or in the future'
                        }"></app-validation>
                    </div>
                  </div>

                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Display Task Till</label>
                      <input
                        type="date"
                        class="form-control"
                        formControlName="displayToDatetime"
                        id="exampleFormControlInput1"
                        [ngClass]="{
                          'is-invalid': f['displayToDatetime'].errors && f['displayToDatetime'].touched
                        }" />
                      <app-validation
                        field="displayToDatetime"
                        [form]="calendarEventForm"
                        [error]="{
                          invalid: 'Display Task Till must be greater than or Display Task From'
                        }"></app-validation>
                    </div>
                  </div>
                  <!-- <div class="col-12">
                    <div class="col-12 mb-2"></div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="Employee" formControlName="notify" />
                      <label class="form-check-label" for="pfRadio">Send Notification for this Task</label>
                    </div>
                  </div> -->
                </div>
              </form>
            </div>
            <div class="col-12 col-md-6">
              <p>Upload Documents</p>
              <app-multiple-file-selector
                [maxAllowedSizeInMB]="2"
                [allowedTypes]="[
                  'application/pdf',
                  'image/jpeg',
                  'image/png',
                  'application/msword',
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  'message/rfc822'
                ]"
                (chooseFiles)="handleFileInput($event)"
                (removeFiles)="clearSelectedFiles($event)"></app-multiple-file-selector>
              <app-attachment-list
                *ngIf="calendarDetail"
                [attachments]="calendarDetail?.documents"
                [companyEntityId]="calendarDetail?.companyEntityId"></app-attachment-list>
              <div id="images-show"></div>
            </div>

            <div class="col-12 d-flex justify-content-end acvtypglastbtn">
              <button type="button" class="btn-actvtytp" (click)="saveAndExit()">SAVE & EXIT</button>
              <button type="button" class="btn-discard" (click)="exit()">EXIT</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div *ngIf="showImport">
  <app-bulk-import
    [showNavBar]="false"
    [showLeftMenu]="false"
    [validator]="importValidator"
    (importClose)="showImport = false"
    [close]="false"></app-bulk-import>
</div>
